<template>
    <div>
        <modal :show="show">
            <div class="modal-header">
                <h5 class="modal-title">Transaction History</h5>
                <a href="javascript:void(0)" v-on:click="close()" class="close">
                    <em class="icon ni ni-cross"></em>
                </a>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-tranx">
                            <thead>
                                <tr class="tb-tnx-head">
                                    <th class="tb-tnx-info">
                                        Date
                                    </th>
                                    <th class="tb-tnx-info">
                                        Amount
                                    </th>
                                    <th class="tb-tnx-info">
                                        Type
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in transactionList" v-bind:key="item.id" class="tb-tnx-item">
                                    <td class="tb-tnx-info">
                                        {{getDate(item.date)}}
                                    </td>
                                    <td class="tb-tnx-info">
                                        {{AmountFormat(item.debit-item.credit)}}
                                    </td>
                                    <td class="tb-tnx-info">
                                        <span v-if="item.transactionType==1" class="badge badge-dot bg-success">Direct Bonus</span>
                                        <span v-if="item.transactionType==2" class="badge badge-dot bg-success">InDirect Bonus</span>
                                        <span v-if="item.transactionType==3" class="badge badge-dot bg-success">UniLevel Bonus</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button type="button" class="btn btn-danger btn-round" v-on:click="close()">Cancel</button>
            </div>
        </modal>

    </div>
</template>
<script>
    import moment from "moment";

    export default {
        props: ['transactionList', 'show'],
        data: function () {
            return {
                loading: false
            }
        },
        methods: {
            close: function () {
                this.$emit('close');
            },

            getDate: function (date) {
                return moment(date).format('llll');
            },

            AmountFormat: function (amount) {
                return '$'+parseFloat(amount).toFixed(4);
            },
        },

        mounted: function () {

        },

    }
</script>